'use strict';

var template = function(data) {

	var t = '';

	data.forEach(function() {

		t += '<div class="slideshow__cell"></div>';

	});

	return t;

};

module.exports = {

	template: template

};
